<template>
  <div>
    <!-- Índice de enlaces útiles -->
    <v-card outlined rounded="lg" class="pa-4 mb-3">
      <div class="orbitron-title mb-3">Enlaces útiles</div>

      <div v-if="linksPorFuente.length === 0" class="text-caption grey--text">
        Añade tus enlaces en el array <code>Links</code> de este componente.
      </div>

      <div v-else class="d-flex flex-column ga-4">
        <div
          v-for="grupo in linksPorFuente"
          :key="grupo.fuente"
          class="fuente-grupo"
        >
          <div
            class="fuente-titulo"
            :style="{ color: colorFuente(grupo.fuente) }"
          >
            <span
              class="fuente-punto"
              :style="{ background: colorFuente(grupo.fuente) }"
            ></span>

            {{ grupo.fuente }}
          </div>

          <div class="d-flex flex-column ga-2 ma-1">
            <a
              v-for="(link, i) in grupo.items"
              :key="i"
              :href="link.url"
              :target="link.download ? null : '_blank'"
              :rel="link.download ? null : 'noopener noreferrer'"
              :download="link.download ? link.nombreArchivo : null"
              class="omie-link"
              :style="{ borderLeftColor: colorFuente(grupo.fuente) }"
            >
              <!-- Icono descarga -->
              <span
                v-if="link.download"
                class="material-symbols-outlined omie-link-icon"
              >
                download
              </span>

              <!-- Icono enlace externo -->
              <span
                v-else
                class="material-symbols-outlined omie-link-icon"
              >
                open_in_new
              </span>

              <span class="omie-link-texto">
                <span class="omie-link-titulo">
                  {{ link.titulo }}
                </span>

                <span
                  v-if="link.descripcion"
                  class="omie-link-desc"
                >
                  {{ link.descripcion }}
                </span>
              </span>

              <span
                v-if="link.download"
                class="download-badge"
              >
                PDF
              </span>
            </a>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Mapa de activos con capas meteo/CO2 -->
    <MapaActivos />
  </div>
</template>

<script>
import MapaActivos from "@/components/MapaActivos.vue";

export default {
  name: "PanelControl",

  components: {
    MapaActivos,
  },

  data() {
    return {
      Links: [
        /* =========================
           DOCUMENTACIÓN ELECTROLIGA
        ========================== */
        {
          titulo: "Descargar manual de uso",
          url: `${process.env.BASE_URL}documentos/Manual_usuario_Electroliga.pdf`,
          descripcion: "Manual de usuario completo de Electroliga",
          fuente: "Documentación Electroliga",
          download: true,
          nombreArchivo: "Manual_usuario_Electroliga.pdf",
        },

        {
          titulo: "Descargar flyer",
          url: `${process.env.BASE_URL}documentos/Flyer_Electroliga.pdf`,
          descripcion: "Flyer informativo de Electroliga",
          fuente: "Documentación Electroliga",
          download: true,
          nombreArchivo: "Flyer_Electroliga.pdf",
        },

        /* =========================
           ENLACES EXTERNOS
        ========================== */
        {
          titulo: "Vídeo navegación jugabilidad Electroliga",
          url: "https://youtu.be/BwH_SUyfbrA",
          descripcion:
            "Enlace para visualizar de forma rápida la jugabilidad de la Electroliga",
          fuente:
            "vídeo de youtube",
        },
        {
          titulo: "Precio mercado diario",
          url: "https://www.esios.ree.es/es/analisis/600?vis=1&geoids=3&groupby=minutes15",
          descripcion:
            "Enlace para consultar valores y forma del spot diario español",
          fuente:
            "Sistema de Información del Operador del Sistema (ESIOS)",
        },

        {
          titulo: "Indisponibilidades nucleares",
          url: "https://www.csn.es/estados-operativos1",
          descripcion:
            "Enlace para consultar indisponibilidades de centrales nucleares de España",
          fuente: "Consejo de Seguridad Nuclear (CSN)",
        },

        {
          titulo: "Previsiones de generación renovable",
          url: "https://www.esios.ree.es/es/analisis/10034?vis=1&A00&groupby=minutes15&compare_indicators=10034%2C541",
          descripcion:
            "Enlace para consultar las previsiones de generación de solar y eólica",
          fuente:
            "Sistema de Información del Operador del Sistema (ESIOS)",
        },

        {
          titulo: "Precio del gas",
          url: "https://www.mibgas.es/es/market-results",
          descripcion:
            "Enlace para consultar el precio del gas publicado por MIBGAS",
          fuente: "Mercado Ibérico del Gas (MIBGAS)",
        },
      ],
    };
  },

  computed: {
    linksPorFuente() {
      const grupos = {};

      for (const link of this.Links) {
        if (!link || !link.url || !link.titulo) continue;

        const fuente = (link.fuente || "").trim() || "Otros";

        if (!grupos[fuente]) {
          grupos[fuente] = [];
        }

        grupos[fuente].push(link);
      }

      return Object.keys(grupos)
        .sort((a, b) => a.localeCompare(b, "es"))
        .map((fuente) => ({
          fuente,
          items: grupos[fuente],
        }));
    },
  },

  methods: {
    colorFuente(fuente) {
      /*
       * Dejamos la documentación de Electroliga
       * siempre con el verde corporativo.
       */
      if (fuente === "Documentación Electroliga") {
        return "#31635f";
      }

      let h = 0;

      for (let i = 0; i < fuente.length; i++) {
        h = (h * 31 + fuente.charCodeAt(i)) % 360;
      }

      return `hsl(${h}, 60%, 42%)`;
    },
  },
};
</script>

<style scoped>
.orbitron-title {
  font-family: "Orbitron", sans-serif;
  font-weight: bold;
  font-size: 1.1rem;
}

.fuente-grupo {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fuente-titulo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.fuente-punto {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.omie-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-left-width: 3px;
  text-decoration: none;
  color: inherit;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}

.omie-link:hover {
  background-color: rgba(49, 99, 95, 0.06);
  border-color: rgba(49, 99, 95, 0.3);
  transform: translateY(-1px);
}

.omie-link-icon {
  font-size: 18px;
  opacity: 0.7;
}

.omie-link-texto {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  flex: 1;
  min-width: 0;
}

.omie-link-titulo {
  font-weight: 600;
}

.omie-link-desc {
  font-size: 0.8rem;
  opacity: 0.7;
}

.download-badge {
  flex-shrink: 0;
  padding: 3px 7px;
  border-radius: 6px;
  background: rgba(49, 99, 95, 0.1);
  color: #31635f;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}
</style>